const host = "https://kt3mkkh4-3001.jpe1.devtunnels.ms/";

export default host;
